import { Box, Typography } from '@mui/material';
import { Stack } from '@mui/material';

const NotSupportMobile = () => {
  return (
    <Stack
      position={'relative'}
      paddingTop={5}
      paddingBottom={5}
      flexGrow={1}
      flex={1}
      alignItems={'center'}
      justifyContent={'center'}>
      <Box textAlign={'center'}>
        <img className='max-w-[278px]' src='/imgs/stages/not-support-on-mobile.png' alt='Mobile not supported' />
        <Typography
          variant='body1'
          className='font-gotham mt-6'
          sx={{
            color: 'white',
          }}>
          Mobile access is unavailable. <br /> Please switch to a desktop device to <br /> continue.
        </Typography>
      </Box>
    </Stack>
  );
};

export default NotSupportMobile;
